<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="用户">
								<a-input v-model="queryParams.user" placeholder="ID/昵称" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="性别">
								<a-select v-model="queryParams.sex" placeholder="请选择" allowClear>
									<a-select-option value="MALE">男</a-select-option>
									<a-select-option value="FEMALE">女</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="状态">
								<a-select v-model="queryParams.status" placeholder="请选择" allowClear>
									<a-select-option value="PENDING">待审核</a-select-option>
									<a-select-option value="NORMAL">已通过</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="申请时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && { float: 'right', overflow: 'hidden' } || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="reset()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<a-table :rowKey="record => record.actorId" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				<template slot="user" slot-scope="record">
					<div class="user">
						<div class="user-left">
							<img class="cover-img" :src="record.avatarUrl" width="48px" height="48px" />
							<span style="color:#acacac">{{ record.account }}</span>
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.nickname }}</span>
								<span v-if="record.status == 'DISABLE'" class="error">【已禁用】</span>
								<span v-else-if="record.status == 'DEACTIVATE'" class="error">【已注销】</span>
							</p>
							<p class="row">
								<span class="user-right-detail" v-if="record.sex == 'MALE'">男</span>
								<span class="user-right-detail" v-else>女</span>
								<span class="user-right-detail">{{ record.age }}岁</span>
								<span class="user-right-detail">{{ record.province }}{{ record.city }}</span>
								<span class="user-right-detail">{{ dictTrans('maritalStates', record.maritalStatus) || '-' }}</span>
							</p>
							<p class="row" v-if="record.isVip == 'Y'">
								<span style="font-weight: bold; color:red">VIP</span>
							</p>
						</div>
					</div>
				</template>

				<template slot="actorStatus" slot-scope="record">
					<span v-if="record.actorStatus === 'PENDING'" class="wait">待审核</span>
					<span v-else-if="record.actorStatus === 'NORMAL'" class="success">已通过</span>
					<span v-else>{{ record.actorStatus || '-' }}</span>
				</template>

				<template slot="isOnline" slot-scope="record">
					<div class="complex">
						<span class="online-status" :class="{ 'online': record.isOnline == 'Y', 'offline': record.isOnline != 'Y' }">
							{{ record.isOnline == 'Y' ? '在线' : '离线' }}
						</span>
					</div>
				</template>

				<template slot="account" slot-scope="record">
					<div class="complex">
						<span>金币：{{ record.gold }}</span>
						<span>积分：{{ record.score }}</span>
					</div>
				</template>

				<template slot="recharge_withdrawal" slot-scope="record">
					<div class="complex">
						<span>充值：{{ record.rechargeAmount }}元 / <span style="color:#acacac;">{{ record.rechargeNum != null ? record.rechargeNum : 0 }}次</span></span>
						<span>提现：{{ record.cashoutAmount }}元 / <span style="color:#acacac;">{{ record.cashoutNum != null ? record.cashoutNum : 0 }}次</span></span>
					</div>
				</template>

				<template slot="call" slot-scope="record">
					<div class="complex">
						<span>时长：{{ record.totalCallLen != null ? record.totalCallLen : 0 }}分钟</span>
						<span>次数：{{ record.totalCallNum != null ? record.totalCallNum : 0 }}次</span>
					</div>
				</template>

				<template slot="charm" slot-scope="record">
					<div class="complex">
						<span>{{ record.charm }} / <span style="color:#acacac;">{{ record.weighting }}</span></span>
					</div>
				</template>

				<template slot="date" slot-scope="record">
					<div class="complex">
						<span>申请：{{ record.actorCreated || '-' }}</span>
						<span style="color: #acacac;">活跃：{{ record.activeTime || '-' }}</span>
					</div>
				</template>

				<template slot="action" slot-scope="record">
					<a @click="openDetail(record.id)">详情</a>
					<template v-if="record.actorStatus === 'PENDING'">
						<a-divider type="vertical" />
						<a @click="auditPass(record)">通过</a>
						<a-divider type="vertical" />
						<a class="error" @click="auditReject(record)">拒绝</a>
					</template>
					<template v-else-if="record.actorStatus === 'NORMAL'">
						<a-divider type="vertical" />
						<a class="error" @click="cancelActor(record)">取消资格</a>
					</template>
				</template>
			</a-table>

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>

		<a-drawer
			:title="detailDrawerTitle"
			placement="right"
			:width="1360"
			:visible="detailDrawerVisible"
			:destroyOnClose="true"
			@close="closeDetailDrawer"
		>
			<user-detail
				v-if="detailDrawerVisible && detailUserId"
				:id="detailUserId"
				:embedded="true"
				@loaded="onDetailLoaded"
			/>
		</a-drawer>

		<a-modal
			v-model="reasonVisible"
			:title="reasonTitle"
			:footer="null"
			width="520px"
			destroyOnClose
			@cancel="closeReason"
		>
			<a-textarea v-model="reasonText" :rows="4" placeholder="请输入原因" :maxLength="200" />
			<div class="reason-footer">
				<a-button @click="closeReason">取消</a-button>
				<a-button type="primary" :loading="reasonLoading" @click="submitReason">确定</a-button>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import moment from 'moment';
	import UserDetail from '@/pages/member/user/UserDetail.vue';
	import { actorList, actorAuditPass, actorAuditReject, actorCancel } from '@/api/member/actor';
	import { dictTrans } from '@/utils/dictTrans.js';

	const tableColumns = [
		{ title: '#', dataIndex: 'actorId' },
		{ title: '用户', scopedSlots: { customRender: 'user' } },
		{ title: '审核状态', scopedSlots: { customRender: 'actorStatus' } },
		{ title: '在线', scopedSlots: { customRender: 'isOnline' } },
		{ title: '账户', scopedSlots: { customRender: 'account' } },
		{ title: '充提', scopedSlots: { customRender: 'recharge_withdrawal' } },
		{ title: '通话', scopedSlots: { customRender: 'call' } },
		{ title: '魅力', scopedSlots: { customRender: 'charm' } },
		{ title: '时间', scopedSlots: { customRender: 'date' } },
		{ title: '操作', scopedSlots: { customRender: 'action' } }
	];

	export default {
		components: {
			UserDetail
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				createTime: [],
				detailDrawerVisible: false,
				detailUserId: null,
				detailDrawerTitle: '用户详情',
				reasonVisible: false,
				reasonLoading: false,
				reasonText: '',
				reasonTitle: '',
				reasonAction: '',
				reasonRecord: null
			};
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			dictTrans,
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				actorList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList || [];
					this.tableLoading = false;
				}).catch(() => {
					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				if (!values || !values.length) {
					this.queryParams.startCreateTime = undefined;
					this.queryParams.endCreateTime = undefined;
					return;
				}
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			reset() {
				this.createTime = [];
				this.queryParams = {};
				this.pageIndex = 1;
				this.fetchTableData();
			},
			openDetail(id) {
				this.detailUserId = id;
				this.detailDrawerTitle = `用户详情 (${id})`;
				this.detailDrawerVisible = true;
			},
			onDetailLoaded({ nickname, id }) {
				this.detailDrawerTitle = `${nickname || '用户详情'} (${id})`;
			},
			closeDetailDrawer() {
				this.detailDrawerVisible = false;
				this.detailUserId = null;
				this.detailDrawerTitle = '用户详情';
			},
			auditPass(record) {
				this.$confirm({
					title: '确认通过',
					content: `确定通过聊客「${record.nickname}」的申请吗？`,
					onOk: () => {
						return actorAuditPass(record.actorId).then(res => {
							if (!res.isSucceed) {
								this.$message.error(res.message || '操作失败');
								return;
							}
							this.$message.success('已通过');
							this.fetchTableData();
						});
					}
				});
			},
			auditReject(record) {
				this.openReason(record, 'reject');
			},
			cancelActor(record) {
				this.openReason(record, 'cancel');
			},
			openReason(record, action) {
				this.reasonRecord = record;
				this.reasonAction = action;
				this.reasonText = '';
				this.reasonTitle = action === 'reject' ? '拒绝聊客申请' : '取消聊客资格';
				this.reasonVisible = true;
			},
			closeReason() {
				this.reasonVisible = false;
				this.reasonRecord = null;
				this.reasonText = '';
			},
			submitReason() {
				const message = (this.reasonText || '').trim();
				if (!message) {
					this.$message.warning('请输入原因');
					return;
				}
				const record = this.reasonRecord;
				const request = this.reasonAction === 'reject'
					? actorAuditReject(record.actorId, message)
					: actorCancel(record.actorId, message);
				this.reasonLoading = true;
				request.then(res => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '操作失败');
						return;
					}
					this.$message.success(this.reasonAction === 'reject' ? '已拒绝' : '已取消资格');
					this.closeReason();
					this.fetchTableData();
				}).finally(() => {
					this.reasonLoading = false;
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.user {
		display: flex;
		flex-direction: row;

		.user-left {
			display: flex;
			flex-direction: column;
			margin-right: 5px;
			text-align: center;

			span {
				font-size: 12px;
			}
		}

		.user-right {
			p.first {
				display: flex;
				flex-direction: row;
				margin: 0;

				.nickname {
					color: #686868;
					font-weight: bold;
				}
			}

			p.row {
				font-size: 12px;
				color: #acacac;
				margin: 0;
			}

							.user-right-detail {
				margin-right: 5px;
			}
		}
	}

	.complex {
		display: flex;
		flex-direction: column;

		.online-status {
			&.online {
				color: #52c41a;
			}
			&.offline {
				color: #8c8c8c;
			}
		}
	}

	.success { color: #52c41a; }
	.wait { color: #faad14; }
	.error { color: #f5222d; }

	.reason-footer {
		margin-top: 16px;
		text-align: right;

		.ant-btn + .ant-btn {
			margin-left: 8px;
		}
	}
</style>
